<div class="modal-header" id="isModalThere">
  <span appCuteIcon class="mr-2 px-2-5 px-xl-0" folder="kopa-branding"
        type="full-logo-no-words"
        sizeInPixels="32"></span>
  <h4 class="modal-title pull-left">Wait!</h4>
  <button type="button" class="close pull-right" aria-label="Close" (click)="closeModal()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body mx-2 mx-md-4">
  <!-- Form -->
  <form id="voucherForm" class="js-validate w-100 mx-md-auto">
    <!-- Title -->
    <div class="mb-7">
      <h1 class="h3 text-primary font-weight-normal mb-0">Save <span class="font-weight-semi-bold">$100/Person</span> on Your Purchase</h1>
      <p class="text-dark">Enter your name + email and we'll send you an exclusive voucher.</p>
    </div>
    <!-- End Title -->

    <!-- Form Group -->
    <div class="js-form-message form-group">
      <label class="form-label" for="voucherName">
        Name
        <span class="text-danger">*</span>
      </label>
      <input type="name" formControlName="name" class="form-control" name="name" id="voucherName" placeholder="Name" aria-label="Name" required
             data-msg="Please enter a valid name."
             data-error-class="u-has-error"
             data-success-class="u-has-success">
    </div>
    <div class="js-form-message form-group">
      <label class="form-label mt-2" for="voucherEmail">
        Email address
        <span class="text-danger">*</span>
      </label>
      <input type="email" formControlName="email" class="form-control" name="email" id="voucherEmail" placeholder="Email address" aria-label="Email address" required
             data-msg="Please enter a valid email address."
             data-error-class="u-has-error"
             data-success-class="u-has-success">
    </div>
    <!-- End Form Group -->

    <!-- Button -->
    <div class="row align-items-center mb-5">
      <div class="col-4 col-sm-6">
        <a class="small text-gray link-muted" (click)="closeModal()">No Thanks</a>
      </div>

      <div class="col-8 col-sm-6 text-right">
        <button type="submit" class="btn btn-primary btn-pill transition-3d-hover">Send Voucher<app-fa-icon iconName="chevron-right" color="white" classes="ml-2"></app-fa-icon></button>
      </div>
    </div>
    <!-- End Button -->
  </form>
  <!-- End Form -->
</div>
